import { render, staticRenderFns } from "./contract-item.vue?vue&type=template&id=4952ebb8&scoped=true"
import script from "./contract-item.vue?vue&type=script&lang=js"
export * from "./contract-item.vue?vue&type=script&lang=js"
import style0 from "./contract-item.vue?vue&type=style&index=0&id=4952ebb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952ebb8",
  null
  
)

export default component.exports